import Phaser from 'phaser';

import './css/style.css';

import RoundRectanglePlugin from 'phaser3-rex-plugins/plugins/roundrectangle-plugin.js';
import TagTextPlugin from 'phaser3-rex-plugins/plugins/tagtext-plugin.js';
import SliderPlugin from 'phaser3-rex-plugins/plugins/slider-plugin.js';

import Boot from './js/scenes/Boot.js';
import Preloader from './js/scenes/Preloader.js';
import Menu from './js/scenes/Menu.js';
import VideoIntro from './js/scenes/VideoIntro.js';
import Intro from './js/scenes/Intro.js';
import ActiviteA1 from './js/scenes/ActiviteA1.js';
import ActiviteA2 from './js/scenes/ActiviteA2.js';
import ActiviteA3 from './js/scenes/ActiviteA3.js';
import ActiviteB1 from './js/scenes/ActiviteB1.js';
import ActiviteB2 from './js/scenes/ActiviteB2.js';
import ActiviteB3 from './js/scenes/ActiviteB3.js';
import ActiviteConclu from './js/scenes/ActiviteConclu.js';


//Création du jeu
var game;

window.onload = function () {
    var isMobile = /Mobi|Android/i.test(navigator.userAgent) || Phaser.Input.Touch.enabled;
    var config = {
        autoResize: true,
        width: 1920,
        height: 1080,
        backgroundColor: '#FFFFFF',
        type: Phaser.AUTO,
        parent: "game",
        scale: {
            mode: isMobile ? Phaser.Scale.FIT : Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH
        },
        dom: {
            createContainer: true
        },
        plugins: {
            global: [{
                key: 'rexRoundRectanglePlugin',
                plugin: RoundRectanglePlugin,
                start: true
            },
            {
                key: 'rexTagTextPlugin',
                plugin: TagTextPlugin,
                start: true
            },{
                key: 'rexSlider',
                plugin: SliderPlugin,
                start: true
            }]
        },
        fps:{
            target: 60,
            forceSetTimeOut: true
        },
        scene: [Boot, Preloader, Menu, VideoIntro, Intro,
            ActiviteA1, ActiviteA2, ActiviteA3, 
            ActiviteB1, ActiviteB2, ActiviteB3, ActiviteConclu]
    };

    game = new Phaser.Game(config);

    console.log('  __       __|  __  ');
    console.log('__)  (__| (__| (__) ');
    console.log('        |           ');

    game.scene.start("Boot");
}
